module.exports = __webpack_public_path__ + "img/bcQ.fe1ff840.svg";